<div class="container">
    <div class="loading-panel has-text-centered">
        <span class="">
            <i class="fas fa-spinner fa-spin fa-2x"></i>
        </span>
    </div>
</div>